const columnDataTranspOrder = [
  {
    dataField: 'transpOrder',
    caption: '№ ФЗ отгрузки со склада',
    dataType: 'string'
  }
];
export default columnDataTranspOrder;
